"use strict";
import axios from "axios";
import {getToken, loginTimeOut, TOAST, toast} from "@/utils/utils";
import Qs from 'qs';
import {BASE_URL_FW, BASE_URL_YXB, REQUEST_TYPE_FW, REQUEST_TYPE_YXB} from "@/config";

axios.defaults.baseURL = BASE_URL_YXB
// axios.defaults.headers.common['token'] = getToken();
let config = {
    timeout: 60 * 1000, // Timeout
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    // }
};
const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        if (config.REQUEST_TYPE === REQUEST_TYPE_FW) {
            config.baseURL = BASE_URL_FW
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    response => {
        if (response.config.responseType === 'blob') {
            return response
        }
        if (response.data.status === 901) {
            loginTimeOut()
        } else {
            return response.data
        }
    },
    error => {
        let code = 0
        try {
            code = error.response.data.status
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                toast('网络请求超时', TOAST.error)
                return Promise.resolve(error)
            } else if (error.toString().indexOf('Error: Network Error') !== -1) {
                toast('网络请求错误', TOAST.error)
                return Promise.resolve(error)
            }
        }
        if (code === 5000) {
            loginTimeOut()
        }
        return Promise.resolve(error)
    }
);

// 封装get方法和post方法
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param type 请求类型
 */
export function get(url, params,type = REQUEST_TYPE_YXB) {
    return new Promise((resolve, reject) => {
        _axios.get(url, {
            REQUEST_TYPE: type,
            params: {...params, ...getToken(type)}
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err)
        })
    });
}

/**
 * getfile方法，对应get请求流文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param type 请求类型
 */
export function getfile(url, params, type = REQUEST_TYPE_YXB) {
    return new Promise((resolve, reject) => {
        _axios.get(url, {
            REQUEST_TYPE: type,
            params: {...params, ...getToken(type)},
            responseType: 'blob'
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param type 请求类型
 */
export function post(url, params, type = REQUEST_TYPE_YXB) {
    return new Promise((resolve, reject) => {
        _axios.post(url, params,{
            REQUEST_TYPE: type
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * 上传文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param type 请求类型
 */
export function upload(url, params, type = REQUEST_TYPE_YXB) {
    return new Promise((resolve, reject) => {
        _axios.post(url, params, {
            REQUEST_TYPE: type,
            headers: {'Content-Type': 'multipart/form-data'}
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * postfile方法，对应post请求流文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param type 请求类型
 */
export function postfile(url, params, type = REQUEST_TYPE_YXB) {
    return new Promise((resolve, reject) => {
        _axios.post(url, Qs.stringify({...params, ...getToken(type)}), {
            REQUEST_TYPE: type,
            responseType: 'blob'
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * qspost方法，参数序列化
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param type 请求类型
 */
export function qspost(url, params, type = REQUEST_TYPE_YXB) {
    return new Promise((resolve, reject) => {
        _axios.post(url, Qs.stringify({...params, ...getToken(type)}), {
            REQUEST_TYPE: type
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * qspost方法，参数序列化
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param type 请求类型
 */
export function qspost2(url, params, type = REQUEST_TYPE_YXB) {
    return new Promise((resolve, reject) => {
        _axios.post(url, Qs.stringify(params), {
            REQUEST_TYPE: type
        })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        _axios.put(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * delete
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletefn(url, params) {
    return new Promise((resolve, reject) => {
        _axios.delete(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}